export enum AssessmentAnswerInputType {
  TEXT = 'text',
  NUMBER = 'number',
}

export interface AssessmentAnswerInterface {
  id?: number;
  label?: string;
  category?: string;
  inputType?: AssessmentAnswerInputType;
  imagePath?: string;
  isIdeal?: boolean;      // TODO: consider providing child questions here instead of on the SurveyQuestion
  isSelected?: boolean;
  text?: string;
}

export class AssessmentAnswer implements AssessmentAnswerInterface {
  public id?: number;
  public label?: string;
  public category?: string;
  public inputType?: AssessmentAnswerInputType;
  public imagePath?: string;
  public isIdeal?: boolean;
  public text?: string;

  constructor({
    label = undefined,
    category = undefined,
    inputType = undefined,
    imagePath = undefined,
    isIdeal = undefined,
    text = undefined,
    }: AssessmentAnswerInterface) {
    this.label = label;
    this.category = category;
    this.inputType = inputType;
    this.imagePath = imagePath;
    this.isIdeal = isIdeal;
    this.text = text;
  }
}
